import { ProgrammeDefaultsCategoryKey } from '@dealstack/shared/lib/generated';

/**
 * The same labels the programme settings sidebar uses, so a category is named identically
 * wherever it appears. Vesting is the exception: it has no programme-settings label, only the
 * organisation one, so it resolves from the organisation namespace instead.
 */
export const CATEGORY_LABEL_KEYS: Record<ProgrammeDefaultsCategoryKey, string> = {
	[ProgrammeDefaultsCategoryKey.KYC_SETTING]: 'programme_settings.labels.kyc',
	[ProgrammeDefaultsCategoryKey.INVESTOR_DATA_CUSTOM_FIELDS]:
		'programme_settings.labels.investor_data',
	[ProgrammeDefaultsCategoryKey.VESTING_TERMS]: 'programme_defaults.vesting_terms',
	[ProgrammeDefaultsCategoryKey.MASTER_DOCUMENTS]: 'programme_settings.labels.documents',
	[ProgrammeDefaultsCategoryKey.TAX_AND_COMPLIANCE]: 'programme_settings.labels.tax',
	[ProgrammeDefaultsCategoryKey.EMAIL_TEMPLATES]: 'programme_settings.labels.email_templates',
	[ProgrammeDefaultsCategoryKey.EMAIL_REMINDERS]: 'programme_settings.labels.automated_emails',
	[ProgrammeDefaultsCategoryKey.MEMBERS]: 'programme_defaults.members.title',
};

export const isOrganizationNamespacedLabel = (category: ProgrammeDefaultsCategoryKey): boolean =>
	category === ProgrammeDefaultsCategoryKey.VESTING_TERMS ||
	category === ProgrammeDefaultsCategoryKey.MEMBERS;
